
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/gold-loans/about-gold-loan-from-home",
      function () {
        return require("private-next-pages/help/gold-loans/about-gold-loan-from-home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/gold-loans/about-gold-loan-from-home"])
      });
    }
  